import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDarkMode } from '../../contexts/DarkModeContext';
import { getParentChildren, getChildSubjects } from "../../redux/slices/lessonsSlice";
import { getChildSubjectTests } from "../../redux/slices/childTestsSlice";
import styles from "./ParentChildTests.module.css";

function ParentChildTests() {
  const { isDarkMode } = useDarkMode();
  const dispatch = useDispatch();
  const { parentChildren, parentChildrenLoading, childSubjects, childSubjectsLoading } = useSelector((state) => state.lessons);
  const { childSubjectTests, childSubjectTestsLoading } = useSelector((state) => state.childTests);
  const { currentUser } = useSelector((state) => state.auth);
  
  const [selectedChild, setSelectedChild] = useState(null);
  const [selectedSubjectId, setSelectedSubjectId] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isGuestMode, setIsGuestMode] = useState(true);

  const userRole = currentUser?.role || localStorage.getItem("userRole");
  const isParent = userRole === "parent";

  // التحقق من وجود token عند تحميل المكون
  useEffect(() => {
    const token = localStorage.getItem("token3almny");
    if (token) {
      setIsGuestMode(false);
      if (isParent) {
        dispatch(getParentChildren());
      }
    } else {
      setIsGuestMode(true);
    }
  }, [dispatch, isParent]);

  // جلب مواد الابن عند تغيير الابن المختار
  useEffect(() => {
    if (selectedChild) {
      console.log("جلب مواد الابن:", selectedChild.id);
      dispatch(getChildSubjects(selectedChild.id));
    }
  }, [selectedChild, dispatch]);

  // جلب اختبارات المادة عند تغيير الابن أو المادة
  useEffect(() => {
    if (selectedChild) {
      console.log("جلب اختبارات المادة:", selectedChild.id, "المادة:", selectedSubjectId);
      dispatch(getChildSubjectTests({ 
        childId: selectedChild.id, 
        subjectId: selectedSubjectId,
        page: currentPage,
        perPage: 10
      }));
    }
  }, [selectedChild, selectedSubjectId, currentPage, dispatch]);

  // تحديث selectedChild عند تغيير parentChildren
  useEffect(() => {
    if (parentChildren.length > 0 && !selectedChild) {
      const firstChild = parentChildren[0];
      setSelectedChild(firstChild);
      // جلب مواد الابن الأول مباشرة
      if (firstChild) {
        console.log("تعيين الابن الأول وجلب مواده:", firstChild.id);
        dispatch(getChildSubjects(firstChild.id));
      }
    }
  }, [parentChildren, selectedChild, dispatch]);

  // جلب اختبارات عند تغيير الابن أو المادة
  useEffect(() => {
    if (selectedChild && selectedSubjectId !== null) {
      console.log("جلب اختبارات المادة:", selectedChild.id, "المادة:", selectedSubjectId);
      dispatch(getChildSubjectTests({ 
        childId: selectedChild.id, 
        subjectId: selectedSubjectId,
        page: currentPage,
        perPage: 10
      }));
    }
  }, [selectedChild, selectedSubjectId, currentPage, dispatch]);

  // دالة تغيير المادة
  const handleSubjectChange = (subjectId) => {
    console.log("تغيير المادة إلى:", subjectId);
    setSelectedSubjectId(subjectId);
    setCurrentPage(1); // إعادة تعيين الصفحة عند تغيير المادة
  };

  // دالة تغيير الصفحة
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // دالة بدء الاختبار
  const handleStartTest = (testId) => {
    console.log("بدء الاختبار:", testId);
    // هنا يمكن إضافة التوجيه لصفحة الاختبار
    window.open(`/start-exam/${testId}`, '_blank');
  };

  // التحقق من الصلاحيات
  if (!isParent) {
    return (
      <div className={styles.accessDenied}>
        <h2>غير مسموح لك بالوصول لهذه الصفحة</h2>
      </div>
    );
  }

  if (isGuestMode) {
    return (
      <div className={styles.accessDenied}>
        <h2>يرجى تسجيل الدخول للوصول لهذه الصفحة</h2>
      </div>
    );
  }

  return (
    <section className={`${styles.parentChildTestsSection} ${isDarkMode ? styles.darkMode : styles.lightMode}`} style={{padding : "140px 0"}}>
      {/* Animated Background */}
      <div className={styles.animatedBackground}>
        <div className={styles.floatingElement}>📚</div>
        <div className={styles.floatingElement}>✏️</div>
        <div className={styles.floatingElement}>🎯</div>
        <div className={styles.floatingElement}>📝</div>
        <div className={styles.floatingElement}>🧠</div>
        <div className={styles.floatingElement}>⭐</div>
      </div>

      <div className={styles.container}>
        {/* Breadcrumb */}
   

        {/* Header */}
        <div className={styles.header}>
          <h1 className={styles.title}>اختبارات الأبناء</h1>
          <p className={styles.subtitle}>تابع اختبارات أبنائك في المواد المختلفة</p>
        </div>

        {/* Child Selector */}
        <div className={styles.childSelector}>
          <label htmlFor="childSelect" className={styles.label}>
            اختر الابن:
          </label>
          <select
            id="childSelect"
            className={styles.select}
            value={selectedChild?.id || ""}
                           onChange={(e) => {
                 console.log("تم تغيير الابن إلى:", e.target.value);
                 const child = parentChildren.find(c => c.id == e.target.value);
                 console.log("الابن المختار:", child);
                 setSelectedChild(child);
                 // إعادة تعيين المادة إلى الكل عند تغيير الابن
                 setSelectedSubjectId(0);
                 setCurrentPage(1);
               }}
            disabled={parentChildrenLoading}
          >
            {parentChildrenLoading ? (
              <option>جاري التحميل...</option>
            ) : parentChildren.length > 0 ? (
              parentChildren.map(child => (
                <option key={child.id} value={child.id}>
                  {child.name}
                </option>
              ))
            ) : (
              <option>لا يوجد أبناء</option>
            )}
          </select>
        </div>

                  {/* Subject Tabs */}
          {selectedChild && (
            <div className={styles.subjectsTabs}>
              <div className={styles.tabsContainer}>
                {/* خيار الكل */}
                <button
                  className={`${styles.subjectTab} ${selectedSubjectId === 0 ? styles.active : ''}`}
                  onClick={() => handleSubjectChange(0)}
                >
                  <img 
                    src="/science.png" 
                    alt="الكل" 
                    className={styles.tabIcon} 
                  />
                  <span>الكل</span>
                </button>
                
                {/* باقي المواد */}
                {childSubjects?.data && childSubjects.data.length > 0 && childSubjects.data.map((subject) => (
                  <button
                    key={subject.id}
                    className={`${styles.subjectTab} ${selectedSubjectId === subject.id ? styles.active : ''}`}
                    onClick={() => handleSubjectChange(subject.id)}
                  >
                    <img 
                      src="/science.png" 
                      alt={subject.title} 
                      className={styles.tabIcon} 
                    />
                    <span>{subject.title}</span>
                  </button>
                ))}
              </div>
            </div>
          )}

        {/* Tests Section */}
        <div className={styles.testsSection}>
          <div className={styles.sectionHeader}>
                         <h2 className={styles.sectionTitle}>
               {selectedSubjectId === 0 ? 'جميع الاختبارات' : `اختبارات ${childSubjects?.data?.find(s => s.id === selectedSubjectId)?.title || 'المادة'}`}
             </h2>
            {childSubjectTests?.result?.pagination && (
              <span className={styles.testsCount}>
                إجمالي الاختبارات: {childSubjectTests.result.pagination.total}
              </span>
            )}
          </div>

          {/* Loading Spinner */}
          {childSubjectTestsLoading && (
            <div className={styles.loadingSpinner}>
              <div className={styles.spinner}></div>
              <p>جاري تحميل الاختبارات...</p>
            </div>
          )}

          {/* Tests Grid */}
          {!childSubjectTestsLoading && childSubjectTests?.result?.data && childSubjectTests.result.data.length > 0 ? (
            <div className={styles.testsGrid}>
              {childSubjectTests.result.data.map((test) => (
                <div key={test.id} className={styles.testCard}>
                  <div className={styles.testHeader}>
                    <img 
                      src={test.subject_image || "/science.png"} 
                      alt={test.subject_title} 
                      className={styles.subjectImage}
                      onError={(e) => {
                        e.target.src = "/science.png";
                      }}
                    />
                    <div className={styles.testInfo}>
                      <h3 className={styles.testTitle}>{test.title}</h3>
                      <span className={styles.subjectName}>{test.subject_title}</span>
                    </div>
                  </div>
                  
                  <div className={styles.testDetails}>
                    <div className={styles.detailItem}>
                      <span className={styles.detailLabel}>المدرس:</span>
                      <span className={styles.detailValue}>{test.teacher_name}</span>
                    </div>
                    <div className={styles.detailItem}>
                      <span className={styles.detailLabel}>التاريخ:</span>
                      <span className={styles.detailValue}>{new Date(test.day).toLocaleDateString('ar-EG')}</span>
                    </div>
                    <div className={styles.detailItem}>
                      <span className={styles.detailLabel}>الوقت:</span>
                      <span className={styles.detailValue}>{test.start_time}</span>
                    </div>
                    <div className={styles.detailItem}>
                      <span className={styles.detailLabel}>المدة:</span>
                      <span className={styles.detailValue}>{test.duration_time}</span>
                    </div>
                  </div>
                  
                                     {/* تم إزالة زر بدء الاختبار */}
                </div>
              ))}
            </div>
          ) : !childSubjectTestsLoading && (
            <div className={styles.noTests}>
              <p>لا توجد اختبارات متاحة في هذه المادة</p>
            </div>
          )}

          {/* Pagination */}
          {childSubjectTests?.result?.pagination && childSubjectTests.result.pagination.pages_count > 1 && (
            <div className={styles.pagination}>
              <button
                className={styles.paginationBtn}
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                السابق
              </button>
              
              <span className={styles.pageInfo}>
                صفحة {currentPage} من {childSubjectTests.result.pagination.pages_count}
              </span>
              
              <button
                className={styles.paginationBtn}
                disabled={currentPage === childSubjectTests.result.pagination.pages_count}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                التالي
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default ParentChildTests;
